import { tickerItems } from "@/mocks/homeData";

export default function NewsTicker() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <section id="live" className="scroll-mt-20 border-b border-background-300/70 bg-secondary-900">
      <div className="mx-auto flex w-full items-center gap-3 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 font-label text-xs font-bold text-secondary-950">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-fill text-xs"></i>
          </span>
          滚动短讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-8">
            {doubled.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap font-label text-sm text-secondary-100/90"
              >
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}